import React from 'react'
import {isEmpty} from 'react-lf-tools'
import {getSession} from '../../../hooks/useStorage/useStorage.jsx'

import {
    general as textsGeneral,
    shoppingCart as textsShoppingCart,
    consultation as textsCosultation, itemBag as textsItemBag, paymentMethods as textsPaymentMethods
} from '../../../translate/Translate.jsx'

import './descriptionConsultation.scss'
import {QrCodeRounded} from "@mui/icons-material";

const DescriptionConsultation = ({data, viewScan, onClick: handleClick}) => {
    const mode = getSession('mode')

    if (viewScan) return <div className={'empty-consultation'}>
        <div className={'button-qr-code'} onClick={handleClick}>
            <label>
                {textsGeneral.clickScan}
            </label>
            <QrCodeRounded color={'icon'}/>
        </div>
    </div>

    if (isEmpty(data)) return null

    if (data.total === 0) return <div className={'empty-consultation'}>
        <div className={'button-qr-code'} onClick={handleClick}>
            <label>
                {textsCosultation.cardConsumption}
            </label>
            <label>
                {textsGeneral.clickScan}
            </label>
            <QrCodeRounded color={'icon'}/>
        </div>
    </div>

    return <div className={'description-consultation'}>
        <div className={'div-data-order-summary-values'}>
            <div className={'div-title'}>
                <label className={'title'}>
                    {textsGeneral.items}
                </label>
            </div>
            {(!!data?.itens.length) && <div className={'div-items'}>
                {data.itens.map((item, i) => <div className={'item'} key={i}>
                        <label className={'description'}>
                            {`${item.qtde}x ${item.descricao}`}
                        </label>
                        <label className={'value'}>
                            {item.total.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })}
                        </label>
                    </div>
                )}
            </div>}
        </div>
        <div className={'div-data-order-summary-values'}>
            <div className={'div-title'}>
                <label className={'title'}>
                    {textsGeneral.orderInformation}
                </label>
            </div>
            {(!!data?.comandas_nomes?.length || false) && <div className={'div-values'}>
                <label className={'description'}>
                    {textsGeneral.identification}
                </label>
                {data.comandas_nomes.map((identification, i) => <label key={i} className={'value'}>
                        {`${identification} `}
                    </label>
                )}
            </div>}
            {(!!data?.comandas?.length || false) && <div className={'div-values'}>
                <label className={'description'}>
                    {(mode === 'card') ? textsGeneral.card : textsGeneral.table}
                </label>
                {data.comandas.map((value, i) => <label key={i} className={'value'}>
                        {`${value} `}
                    </label>
                )}
            </div>}
        </div>
        <div className={'div-data-order-summary-values'}>
            <div className={'div-title'}>
                <label className={'title'}>
                    {textsItemBag.summaryValues}
                </label>
            </div>
            <div className={'div-values'}>
                <label className={'description'}>
                    {textsShoppingCart.subtotal}
                </label>
                <label className={'value'}>
                    {(data?.total_conta || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>
            {(!!data?.servico) && <div className={'div-values'}>
                <label className={'description'}>
                    {textsShoppingCart.service}
                </label>
                <label className={'value'}>
                    {(data?.servico || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>}
            {(!!data?.desconto) && <div className={'div-values'}>
                <label className={'description'}>
                    {textsShoppingCart.discount}
                </label>
                <label className={'value'}>
                    {`- ${discount.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}`}
                </label>
            </div>}

            <div className={'div-values'}>
                <label className={'description'} style={{fontSize: 16, fontWeight: 'bold'}}>
                    {textsShoppingCart.total}
                </label>
                <label className={'description'} style={{fontSize: 16, fontWeight: 'bold'}}>
                    {(data?.total || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>
        </div>
    </div>
}

export default DescriptionConsultation
